import { newClient } from '../axios-client-factory'
import { requireNonNull } from '../../utils/coding-utils'


export const getMyGuildDetail = function() {
  return newClient().post('/guild/guilder/myGuild')
}


export const getWeChatDetail = function (model) {
  return newClient().post('/guild/new-assistant-feedback/records', model)
}

export const editDetailInfo = function (model) {
  return newClient().post('/guild/guilder/updateGuild', model)
}

export const getEditLogList = function (model) {
  return newClient().post('/guild/guilder/editLog', model)
}

/**
 * 更新公会长id，发送验证码
 * @param {*} guildAdminId
 * @returns
 */
export const sendCodeForUpAppUserId = function (guildAdminId) {
  return newClient().post('/guild/apply/guild/sendCodeForUpAppUserId', guildAdminId, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 更新公会长ID
 * @param {*} model
 * @returns
 */
export const apiUpdateGuildAdmin = function (model) {
  return newClient().post('/guild/guilder/updateGuildAdmin',model)
}



// WEBPACK FOOTER //
// ./src/api/guild/my-guild-detail.js